import QuoteWorkflowService from '@/services/quoteWorkflow.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    async performWorkflowAction({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QuoteWorkflowService.performWorkflowAction(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
                commit('setLoading', false, { root: true })
                
        }
    },
    async generateQuotePdf({commit}, id) {
        try {
            // console.log(id)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QuoteWorkflowService.generateQuotePdf(id);
            return result
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async getInitQuoteSendingEmailData({commit}, id) {
        try {
            // console.log(id)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QuoteWorkflowService.getInitQuoteSendingEmailData(id);
            return result
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async sendEmail({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QuoteWorkflowService.sendEmail(payload);
            return result
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async uploadQuoteFile({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await QuoteWorkflowService.uploadQuoteFile(payload);
            return result
        } catch (e) {
            console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
}

const mutations = {
}

export const quoteWorkflow = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}